import { parseByCountry } from "./FormatInputByCountry";

const parseInputFloatToFloat = (value: any) => {
  return parseByCountry(value);
};

export default parseInputFloatToFloat;